import gql from 'graphql-tag';

export class IntegrationsQueries {
  static integrations = gql`
    query ConnectedIntegrations {
      getUserIntegrations {
        name
      }
    }
  `;

  static pipedrive = gql`
    query Pipedrive($name: String!) {
      integration(name: $name) {
        metaData1
        userId
        status
      }
    }
  `;

  static saml = gql`
    query SAML($name: String!) {
      integration(name: $name) {
        metaData1
        metaData2
        metaData3
        identifier
        externalUrl
        userId
      }
    }
  `;

  static stripe = gql`
    query Stripe($name: String!) {
      integration(name: $name) {
        externalUrl
        metaData1
        metaData3
        token
        userId
      }
    }
  `;

  static freshsales = gql`
    query Freshsales($name: String!) {
      integration(name: $name) {
        identifier
      }
    }
  `;

  static authorizeNet = gql`
    query AuthorizeNet($name: String!) {
      integration(name: $name) {
        externalUrl
        metaData1
        metaData2
        metaData3
        token
        userId
        identifier
      }
    }
  `;

  static twilio = gql`
    query Twilio($name: String!) {
      integration(name: $name) {
        metaData1
      }
    }
  `;

  static freshworks = gql`
    query Freshworks($name: String!) {
      integration(name: $name) {
        identifier
      }
    }
  `;

  static googleDocs = gql`
    query GoogleDocs($name: String!) {
      integration(name: $name) {
        status
      }
    }
  `;
}
